import React, {Component} from 'react';

class NoMatch extends Component {
    render() {
        document.title = "صفحه مورد نظر یافت نشد";
        return (
            <div>
                <h1 className="mx-auto text-center p-4">Not Found : 404 Error</h1>
            </div>
        );
    }
}

export default NoMatch;
